import { AxiosError, AxiosResponse } from "axios";
import * as React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import "./subCategory.scss";
import { ReactComponent as BackGray } from "../../../images/backGray.svg";
import "./styles.css";
import Service from "../../../services";
import { BankUserContext } from "../../../bankUserContext";
import { ParseJson, catchError } from "../../../utils/Utils";
import FinSpinner from "../../../commonfields/FinSpinner";
import { QuestionTypes, QuestionnaireComponent } from "dynamic-questionarie";
import { CategoryDetails, OptionsPayload, postQuestionData } from "../../../models/ClientPortalCategoriesDetails/CategoriesDetails";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import { CLIENT_SCREEN_TYPES, RoutesEnum } from "../../../utils/RoutesUtil";
import { Question } from "dynamic-questionarie/dist/esm/models/QuestionarieModel";
import ReactFileViewer from "../../../commonfields/ReactFileViewer";
import { SubCategoryQuestionsForClientPortal } from "../../../models/SharedModel";
import OwnershipQuestionnaireComponent from "../../Ownership/OwnershipQuestionnarieModule/OwnershipQuestionnarieMainCC";
import { sendPhondNumberFormat } from "../../../utils/GeneralUtils";



export interface StateProps {
  data: any;
  parentCategoryName: string;
  spinner: boolean;
  questions: Question[];
  count: number;
  disableNewTaskButton: boolean;
  status: any;
  refreshQuestionsData: boolean;
  fileHandleModal: boolean;
  file: any;
  selectedQuestionObject: Question | null;
  showAIModal: boolean;
  addAnotherNotRequired: any;
}

class ClientQuestionarie extends React.Component<
  WithRouterProps<unknown>,
  StateProps
> {
  addAnotherNotRequired: any;
  constructor(props: any) {
    super(props);
    this.state = {
      data: undefined,
      parentCategoryName: "",
      spinner: false,
      questions: [],
      count: 0,
      disableNewTaskButton: false,
      status: "",
      fileHandleModal: false,
      file: null,
      refreshQuestionsData: false,
      selectedQuestionObject: null,
      showAIModal: false,
      addAnotherNotRequired: "",
    };
  }
  service = new Service();
  static contextType = BankUserContext;

  categoryId = this.props.params.categoryId;
  subcategoryId = this.props.params.subCategoryId;
  clientProductId = this.props.params.clientProductId;
  componentDidMount() {

    if (this.props.params.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.CLIENT_VIEW) {
      this.getClientQuestions();
      this.getCategoriesDetails();
    }

  }





  back = () => {
    this.props.navigate(
      `/${RoutesEnum.CLIENT_QUESTIONARIE}/subCategories/${this.props?.params.screenType}/${this.props?.params.categoryId}/${this.props?.params.clientProductId}`,
      { state: this.props.location.state }
    );
  };







  fileClick = (file: any) => {
    this.setState({ spinner: true });
    this.service
      .getFile(file?.filePath)
      .then((response: any) => {
        if (response.data) {
          const data = { ...response.data, uri: response.data.fileContent };
          this.setState({ file: data });
        }
        this.openFileViewHandler();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ spinner: false });
      });
  };



  modalViewHandler = () => {
    this.setState((prevState) => {
      return { showAIModal: !prevState.showAIModal };
    });
  };


  onSaveQuestion = (question: any, oldAnswer: any) => {
    this.setState({ refreshQuestionsData: false, selectedQuestionObject: question })
    if (
      question.answers &&
      question.answers?.length > 0 &&
      question.answers[0].answer !== ""
    ) {
      if (
        question.questionType === QuestionTypes.FileUpload &&
        question.answers
      ) {
        const fileObj = question.answers[0].answer;
        this.setState({ spinner: true })
        this.service
          .validationByAi(question.answers[0].answer, question.clientQuestionId)
          .then((response: any) => {
            if (response.data.status === true) {
              const aiOverride = false;
              this.service
                .postFileForClientPortal(fileObj, question.clientQuestionId, aiOverride)
                .then((res: any) => {
                  const allQuestions = Object.assign([], this.state.data);
                  const currentQuestion = allQuestions.questions.find(
                    (m: any) => m.clientQuestionId == question.clientQuestionId
                  );
                  if (currentQuestion) {
                    currentQuestion.answers = [
                      { answer: res.data, optionId: null },
                    ];
                    this.setState({ data: allQuestions, refreshQuestionsData: true })

                  }
                })
                .finally(() => {
                  this.setState({ spinner: false })
                });
            } else {
              this.modalViewHandler();
              this.setState({ spinner: false })
            }
          })
          .catch((error: AxiosError) => {
            catchError(error, true);
            this.modalViewHandler();
            this.setState({ spinner: false })
          });
      } else {
        //save the response
        const PostQuestionData: postQuestionData = {
          answer: "",
          clientQuestionId: question.clientQuestionId,
          clientProductId: this.clientProductId,
          options: [],
          requireCopy: false,
        };
        // text, date, text area, signle selection
        PostQuestionData.answer = question.answers[0].answer;
        if (question.options.length > 0) {
          PostQuestionData.options = question.answers.map((item: any) => {
            const Data: OptionsPayload = {
              questionOptionId: item.optionId,
              answer: item.answer,

            };
            return Data;
          });
        }
        if (question.questionType == QuestionTypes.PhoneNumber) {
          if (question.answers[0].answer && question.answers[0].answer.length > 1) {
            PostQuestionData.answer = question.answers[0].answer.length > 1 ? sendPhondNumberFormat(question?.answers[0].answer) : question?.answers[0].answer;
            this.service                                      // for phone number save only if length > 1
              .postSaveClientResponse(PostQuestionData)
              .catch((error: AxiosError) => {
                catchError(error, true);
              });
          }
          else if (question.answers[0].answer && question.answers[0].answer.length === 1) {
            this.service
              .postRemoveresponseData(question.clientQuestionId, this.clientProductId)
              .catch((error: AxiosError) => {
                catchError(error, true);
              });
          }
        }
        if(question.questionType == QuestionTypes.Checkbox){
          if(question.answers[0].answer && question.answers[0].answer){
            this.service                                      
              .postSaveClientResponse(PostQuestionData)
              .catch((error: AxiosError) => {
                catchError(error, true);
              });
          }
          else{
            this.service
              .postRemoveresponseData(question.clientQuestionId, this.clientProductId)
              .catch((error: AxiosError) => {
                catchError(error, true);
              });
          }
        }
        else {
          this.service
            .postSaveClientResponse(PostQuestionData)
            .catch((error: AxiosError) => {
              catchError(error, true);
            });
        }

      }
    } else {
      // remove the response
      if (question.questionType !== QuestionTypes.FileUpload) {
        this.service
          .postRemoveresponseData(question.clientQuestionId, this.clientProductId)
          .catch((error: AxiosError) => {
            catchError(error, true);
          });
      } else {
        if (oldAnswer[question.clientQuestionId] && oldAnswer[question.clientQuestionId].length > 0) {
          // eslint-disable-next-line no-var
          var filePath = null;
          //for removing the dependent question answer
          if (oldAnswer[question.clientQuestionId][0].answer && typeof oldAnswer[question.clientQuestionId][0].answer === "string" ) {
            const fileObj = ParseJson(oldAnswer[question.clientQuestionId][0].answer);
            if (fileObj && fileObj.filePath) {
              filePath = fileObj.filePath;
            }
          } else if (oldAnswer[question.clientQuestionId][0].answer && typeof oldAnswer[question.clientQuestionId][0].answer === "object") {
            const fileObj = oldAnswer[question.clientQuestionId][0].answer;
            if (fileObj && fileObj.filePath) {
              filePath = fileObj.filePath;
            }
          } else if (typeof oldAnswer[question.clientQuestionId][0] === "object" ) {
            // for delete on click of delete button
            filePath = oldAnswer[question.clientQuestionId][0].filePath;
          }
          this.service
            .deleteClientFile(question.clientQuestionId, filePath, this.clientProductId)
            .catch((error: AxiosError) => {
              catchError(error, true);
            });
        }
      }
    }
  };

  uploadFileHandler = () => {
    const { selectedQuestionObject } = this.state;
    if (
      selectedQuestionObject?.answers &&
      selectedQuestionObject.answers?.length > 0 &&
      selectedQuestionObject.answers[0].answer !== ""
    ) {
      const fileObj = selectedQuestionObject?.answers[0].answer;
      this.setState({ spinner: true })
      const aiOverride = true;
      this.service.postFileForClientPortal(fileObj, selectedQuestionObject?.clientQuestionId, aiOverride)
        .then((response: any) => {
          if (response.status == 200) {
            this.modalViewHandler();
          }
          const allQuestions = Object.assign([], this.state.data);
          const currentQuestion = allQuestions?.questions.find(
            (m: any) => m.clientQuestionId == selectedQuestionObject.clientQuestionId
          );
          if (currentQuestion) {
            currentQuestion.answers = [
              { answer: response.data, optionId: null },
            ];
            this.setState({ data: allQuestions, refreshQuestionsData: true });
          }
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        })
        .finally(() => {
          this.setState({ spinner: false })
        });
    }
  };

  onAddGroupQuestion = (
    questionGroupId: any,
    currentSerialNumber: any
  ) => {

    const requestPayload = {
      clientProductId: this.clientProductId,
      questionGroupId: questionGroupId,
      questionnarieCategoryId: this.subcategoryId,
      serialNumber: currentSerialNumber + 1,
    };
    this.setState({ spinner: true, refreshQuestionsData: false })
    this.service.addQuestionGroup(requestPayload).then((response) => {
      this.getClientQuestions();
    });
  };

  getCategoriesDetails = () => {
    this.service
      .getcategoryDetails(
        this.props?.params.categoryId,
        this.props.params.clientProductId
      )
      .then((response: AxiosResponse<CategoryDetails>) => {
        const addAnotherNotRequired = response.data.subcategories.map((m: any) => m.addAnotherNotRequired).find((a) => a)
        this.setState({
          parentCategoryName: response?.data?.name,
          spinner: false,
          addAnotherNotRequired: addAnotherNotRequired,
        });
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        this.setState({ spinner: false });
      });
  }


  getClientQuestions = () => {
    this.setState({ spinner: true })
    this.service
      .getQuestionsBySubCategoryId(this.subcategoryId, this.clientProductId)
      .then((res: AxiosResponse<SubCategoryQuestionsForClientPortal>) => {
        this.setState({ data: res.data, refreshQuestionsData: true, questions: res.data.questions })
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ spinner: false })
      });
  }

  onRemoveGroupQuestion = (
    questionGroupId: any,
    selectedSerialNumber: any
  ) => {

    const requestPayload = {
      clientProductId: this.clientProductId,
      questionGroupId: questionGroupId,
      questionnarieCategoryId: this.subcategoryId,
      serialNumber: selectedSerialNumber,
    };
    this.setState({ spinner: true, refreshQuestionsData: false })
    this.service
      .removeQuestionGroup(requestPayload)
      .then(() => {
        this.getClientQuestions();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        this.setState({ spinner: false })
      });
  };


  onRemoveGroupQuestionBulk = (groupsToDelete: Array<any>) => {
    this.setState({ spinner: true })
    const requestPayload: Array<any> = [];
    groupsToDelete.forEach((item: any) => {
      requestPayload.push({
        clientProductId: this.clientProductId,
        questionGroupId: item.questionGroupId,
        questionnarieCategoryId: this.subcategoryId,
        serialNumber: item.selectedSerialNumber,
      });
    });
    this.service
      .removeQuestionGroupBulk(requestPayload).catch((error: AxiosError) => {
        catchError(error, true);
      }).finally(() => {
        this.setState({ spinner: false })
      });
  };



  setLoader = (value: boolean) => this.setState({ spinner: value });

  openFileViewHandler = () =>
    this.setState({ fileHandleModal: !this.state.fileHandleModal });

  closeModalViewHandler = () => {
    this.modalViewHandler();
    const allQuestions = Object.assign([], this.state.data);
    const currentQuestion = allQuestions.questions.find(
      (m: Question) => m.clientQuestionId == this.state.selectedQuestionObject?.clientQuestionId
    );
    if (currentQuestion) {
      currentQuestion.answers = [];
      this.setState({ questions: allQuestions.questions, refreshQuestionsData: true })
    }
    setTimeout(() => {
      this.setState({ refreshQuestionsData: false })
    }, 300);
    setTimeout(() => {
      const allQuestion = Object.assign([], this.state.data);
      const CurrentQuestion = allQuestion.questions.find(
        (m: Question) => m.clientQuestionId == this.state.selectedQuestionObject?.clientQuestionId
      );
      if (CurrentQuestion) {
        CurrentQuestion.answers = null;
        this.setState({ data: allQuestions, refreshQuestionsData: true })

      }
    }, 500);
  };

  public render() {

    return (
      <>
        {this.state.spinner && <FinSpinner />}
        <div className="subCategoryContainer">
          <div className="headingContainer">
            <div className="subCategoryHeader">
              <Button onClick={this.back} className="backBtn">
                <BackGray />
              </Button>
              {this.state.parentCategoryName}
            </div>
          </div>
          <div className="containerHeading">
            <div className="subCategoryHeader">{this.state?.data?.name}</div>
          </div>
          <div className="subCategory">
            <div className="QuestionnarieReviewWrap m-0">
              {this.props.params.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.CLIENT_VIEW && this.state.data?.name === "Ownership Information" ?
                (
                  <OwnershipQuestionnaireComponent
                    clientProductId={this.props.params.clientProductId}
                    disableFields={this.props.location?.state?.editable ? !this.props.location?.state?.editable : true} />
                ) : (
                  <QuestionnaireComponent
                    onNextPage={undefined}
                    onPreviousPage={undefined}
                    displayNextPrevButtons={false}
                    questionsData={this.state.data ? this.state.questions || [] : []}
                    refreshQuestionsData={this.state.refreshQuestionsData}
                    disableFields={this.props.location?.state?.editable ? !this.props.location?.state?.editable : true}
                    canAddGroupQuestions={true}
                    onAddGroupQuestion={this.onAddGroupQuestion}
                    onRemoveGroupQuestion={this.onRemoveGroupQuestion}
                    formName={"QuestionnaireForm"}
                    onSaveQuestion={this.onSaveQuestion}
                    onClickFile={this.fileClick}
                    addAnotherNotRequired={this.addAnotherNotRequired}
                  />
                )}

              <div className="btnWrapper">
                <Button className="bottomButton" onClick={this.back}>
                  Back to {this.state.parentCategoryName}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="AIModalPopUpContainer">
          <Modal
            className="popup-modal"
            size="md"
            isOpen={this.state.showAIModal}
            fade={false}
            toggle={this.closeModalViewHandler}
          >
            <ModalHeader toggle={this.closeModalViewHandler}>
              <span className="headerText">Is this the correct document?</span>
            </ModalHeader>
            <ModalBody>
              <div className="bodyText">
                <span className="ourSystemText">
                  Our system isn’t sure this is correct.{" "}
                </span>
                <br />
                <span className="areYouSureText">
                  Are you sure this is the {[this.state.selectedQuestionObject?.questionText]}
                </span>
              </div>
              <div className="modalBtnsDiv">
                <button onClick={this.closeModalViewHandler} className="noUploadBtn">
                  No, upload a different file
                </button>
                <button onClick={this.uploadFileHandler} className="yesUploadBtn">
                  Yes, attach this document
                </button>
              </div>
            </ModalBody>
          </Modal>
        </div>

        <div className="fileViewerModalContainer">
          <Modal
            className=" mw-100 w-50 fileViewerModalWrapper"
            isOpen={this.state.fileHandleModal}
            fade={false}
            toggle={this.openFileViewHandler}
          >
            <ModalHeader
              toggle={this.openFileViewHandler}
              className="tc_heading"
            >
              <span>{this.state.file?.fileName} </span>
            </ModalHeader>
            <ModalBody>
              <div className="TC_fileView">
                {this.state.spinner ? (
                  <FinSpinner />
                ) : this.state.file ? (
                  <ReactFileViewer fileDocument={this.state.file} />
                ) : (
                  ""
                )}
              </div>
            </ModalBody>
          </Modal>
        </div>

      </>
    );
  }

}

export default withRouter<WithRouterProps<unknown>>(ClientQuestionarie);
